<template>
  <div id="client-report-wrapper">
    <!-- 1. Filters row (exactly like Team-Report.vue) -->
    <form class="row">
      <div class="col-md-4">
        <label>Report type</label>
        <select v-model="parameters.clientReportType" class="form-select" @change="getReport">
          <option v-for="opt in clientReportTypes" :key="opt.value" :value="opt.value">{{ opt.name }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label>Breakdown</label>
        <select v-model="parameters.breakdown" class="form-select" @change="getReport">
          <option v-for="opt in breakdowns" :key="opt.value" :value="opt.value">{{ opt.name }}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label>Period</label>
        <select v-model="parameters.period" class="form-select" @change="getReport">
          <option v-for="opt in periods" :key="opt.value" :value="opt.value">{{ opt.name }}</option>
        </select>
      </div>
    </form>

    <!-- 2. Total card (centered exactly like the others) -->
    <div class="d-flex justify-content-center">
      <div class="col-md-3">
        <div class="card border-0 shadow card-dashboard">
          <div class="card-body" @click="calculateTotals">
            <h6 class="card-subtitle mb-2 text-muted">Total</h6>
            <h3 class="card-title">{{ total }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. Chart -->
    <div class="d-flex justify-content-center">
      <div class="card" id="card-chart" v-if="!empty">
        <barChart :data="chartData" :key="barChartKey" />
      </div>
      <div class="card" id="card-chart" v-else>
        <h3 class="card-title">No Data to display</h3>
      </div>
    </div>

    <!-- 4. Export buttons row -->
    <div class="d-flex justify-content-center mb-5">
      <button class="btn btn-outline-primary me-3" @click="csvExport(chart)">
        Download Chart Data
      </button>
      <button class="btn btn-outline-primary me-3" :disabled="!clientDetailsIsLoaded" @click="fetchReportDetails">
        Download Chart Details
      </button>
      <button class="btn btn-outline-primary" :disabled="!clientDetailsIsLoaded" @click="fetchEntriesDetails">
        Download Raw Data
      </button>
    </div>

    <!-- 5. Totals modal (bootstrap modal just like your other pages) -->
    <div class="modal fade" id="productModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-m">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Totals</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" />
          </div>
          <div class="modal-body">
            <ul class="list-group">
              <li class="list-group-item" v-for="(value, key) in totals" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { periods, clientReportTypes, breakdowns } from "../assets/variables.js";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";
import { useClientReportStore } from "../stores/clientReport.js";

const clientReportStore = useClientReportStore();

const {
  getTotal: total,
  getChart: chart,
  getParameters: parameters,
  getChartData: chartData,
  getBarChartKey: barChartKey,
  getEmpty: empty,
  getTotals: totals,
  getDetail: details,
  getClientDetailsIsLoaded: clientDetailsIsLoaded,
} = storeToRefs(clientReportStore);

const {
  getReport,
  calculateTotals,
  csvExport,
  convertArrayOfObjectsToCSV,
  fetchReportDetails,
  fetchEntriesDetails,
} = clientReportStore;

let pageReady = ref(false);

onMounted(async () => {
  await getReport();
  pageReady.value = true;
});
</script>

<script>
import { defineComponent } from "vue";
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import { clientReportTypes, periods, breakdowns } from "../assets/variables.js";
export default defineComponent({
  components: {
    barChart,
  },
});
</script>

<style lang="scss">
#client-report-wrapper {
  padding-bottom: 40px;
}
.button-export-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  gap: 10px;
  margin-top: 1.5%;
  margin-bottom: 20px;
  align-items: start;
  justify-self: start;
}
</style>
